/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
// redux
import { useDispatch, useSelector } from "react-redux";
import { getStoreCompanies } from "../../../store/actions";
// page
import OrganizationView from "../../Person/Organization/OrganizationView";
import GradesView from "../../Person/Organization/GradesView";
import GroupsView from "../../Person/Organization/GroupsView";
// import OrganizationHistory from "./OrganizationHistory";
// component
import PageHeader from "../../../components/PageHeader";
import EmployeeRequest from "../../../components/Employee/EmployeeRequest";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import { isEmpty } from "lodash";
import { permissionCheck } from "../../../utils/permission";
import { getEmployeeToExcel } from "../../../apis/employee/employee";
import { downExcelFile } from "../../../utils/download";
import { clipboardCopy } from "../../../utils/browser";

const PersonOrganization = () => {
  const { permissions, company } = useSelector(
    (store) => ({
      company: store.Profile.company,
      permissions: store.Profile.permissions,
    }),
  );
  const history = useHistory();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(0);
  const [mode, setMode] = useState("detail");
  const [targetPermission, setTargetPermission] = useState(null);

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'USER');
      setTargetPermission(permission);
      if (isEmpty(permission)) {
        permissionCheck(history, "USER");
      }
    }
  }, [permissions]);

  const _setActiveTab = (value) => {
    history.push({
      search: `?tab=${value}`
    });
    setActiveTab(value);
  };

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location]);

  const tabList = [
    {
      label: "조직",
      action: _setActiveTab,
      value: "DIVISION",
      type: "division",
      Page: OrganizationView,
      disabled: mode === "modify",
      headerButtonLabel: "조직 개편하기",
      headerButtonAction: () => {
        if (mode === "detail") {
          setMode("modify");
        } else {
          setMode("detail");
          dispatch(getStoreCompanies());
        }
      },
    },
    {
      label: "직급",
      action: _setActiveTab,
      value: "GRADE",
      type: "grade",
      Page: GradesView,
      disabled: mode === "modify",
      headerButtonLabel: "직급 개편하기",
      headerButtonAction: () => {
        if (mode === "detail") {
          setMode("modify");
        } else {
          setMode("detail");
          dispatch(getStoreCompanies());
        }
      },
    },
    {
      label: "그룹",
      action: _setActiveTab,
      value: "GROUP",
      type: "gourp",
      Page: GroupsView,
      disabled: mode === "modify",
      headerButtonLabel: "그룹 개편하기",
      headerButtonAction: () => {
        if (mode === "detail") {
          setMode("modify");
        } else {
          setMode("detail");
          dispatch(getStoreCompanies());
        }
      },
    },
    {
      label: (
        <>
          직원 등록 요청
          {/* <small className="color-red-100 font-size-10">new</small> */}
        </>
      ),
      disabled: mode === "modify",
      action: _setActiveTab,
      value: "EMPLOYEE_REQUEST",
      Page: EmployeeRequest,
    },
    // {
    //   label: "개편 이력",
    //   disabled: mode === "modify",
    //   action: _setActiveTab,
    //   Page: OrganizationHistory,
    // },
  ];

  const headerButtons = [
    {
      label: '회사초대 URL 복사',
      color: "text",
      action: () => {
        clipboardCopy(`https://web.wecake.io/sign-up?comNum=${company.comNum}`, '회사초대 URL이 복사되었습니다.');
      }
    },
    {
      label: (
        <>
          엑셀 다운로드 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      color: "gray-line",
      action: () => {
        getEmployeeToExcel().then(res => {
          downExcelFile(res, "직원목록.xlsx");
        });

      }
    },
    {
      label:
        mode === "detail" && tabList.find(t => t.value === activeTab)
          ? tabList.find(t => t.value === activeTab).headerButtonLabel
          : "개편 끝내기",
      action: tabList.find(t => t.value === activeTab) ? tabList.find(t => t.value === activeTab).headerButtonAction : () => { },
      color: mode === "detail" ? "primary" : "gray-line",
    },

  ];

  return (
    !isEmpty(targetPermission) && (
      <>
        <PageHeader
          title={"직원관리"}
          activeTab={activeTab}
          tabList={tabList}
          buttons={(activeTab === 'EMPLOYEE_REQUEST' || targetPermission.level <= 1) ? [] : headerButtons}
        />
        {tabList.map(({ type, value, Page }, idx) => (
          <React.Fragment key={idx}>
            {value === activeTab ? <Page type={type} mode={mode} permission={targetPermission} isTax={true} /> : <></>}
          </React.Fragment>
        ))}
      </>
    )
  );
};

export default PersonOrganization;
